
import { Search, X, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/useLanguage";

interface ReleasesSearchBarProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearch: () => void;
  isLoading: boolean;
  totalReleases: number;
  filteredCount: number;
}

export function ReleasesSearchBar({
  searchQuery,
  onSearchChange,
  onClearSearch,
  isLoading,
  totalReleases,
  filteredCount
}: ReleasesSearchBarProps) {
  const { t } = useLanguage();

  return (
    <div className="relative">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          type="text"
          placeholder={t('releases.search_placeholder')}
          value={searchQuery}
          onChange={onSearchChange}
          className="pl-10 pr-10"
        />
        {searchQuery && (
          <Button
            variant="ghost"
            size="icon"
            className="absolute right-1 top-1/2 -translate-y-1/2 h-8 w-8 p-0 opacity-70 hover:opacity-100"
            onClick={onClearSearch}
          >
            <X className="h-4 w-4" />
            <span className="sr-only">{t('releases.clear_search')}</span>
          </Button>
        )}
      </div>
      {searchQuery && (
        <div className="mt-2">
          {isLoading ? (
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Loader2 className="h-4 w-4 animate-spin" />
              <span>{t('releases.searching')}</span>
            </div>
          ) : (
            <p className="text-sm text-muted-foreground">
              {filteredCount === 0 
                ? t('releases.no_results')
                : t('releases.search_results', { count: filteredCount })}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
